import { render } from "./GridTipRetinere.vue?vue&type=template&id=e60f6648&ts=true"
import script from "./GridTipRetinere.vue?vue&type=script&lang=ts"
export * from "./GridTipRetinere.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__